import { useCallback } from 'react'
import { useColorScheme } from '~/components/DrawingCanvas/Airflow'
import FPMLegend from '~/components/FPMLegend'
import Panel from '~/components/UIKit/Panel'
import LayerKeys from '~/config/layerKeys'
import routes from '~/config/routes'
import { useFormatLength } from '~/hooks/useFormatLength'
import { AIRFLOW_EVALUATION_POINTS, updateAirflow } from '~/lib/airflow/airflow'
import { useAppDispatch, useAppSelector } from '~/store/hooks'
import { toggleLayerVisibility } from '~/store/layers'
import { setAirflowLayer } from '~/store/objects'
import { AIRFLOW_PANEL } from '~/store/panel/types'
import { Select, SelectItem } from '~/ui/Select'
import { Separator } from '~/ui/Separator'
import { Switch } from '~/ui/Switch'

export default function AirflowPanel() {
  const { products, objects, segments, obstructions, airflow } = useAppSelector(state => state.objects.present)
  const formatLength = useFormatLength()
  const isVisible = useAppSelector(state => state.layers.layers.AIRFLOW.visible)
  const isTouchUI = useAppSelector(state => state.userInterface.isTouchUI)
  const colorScheme = useColorScheme()
  const dispatch = useAppDispatch()

  const onUpdateAirflow = useCallback(() => {
    updateAirflow(dispatch, { products, objects, segments, obstructions })
  }, [products, objects, segments, obstructions, dispatch])

  return (
    <Panel title="Airflow" helpUrl={routes.help.airflow.replace('/', '')} landscape panelKey={AIRFLOW_PANEL}>
      <div className="flex flex-row gap-3 p-3">
        {isTouchUI && (
          <>
            <Switch
              isSelected={isVisible}
              onChange={selected => {
                if (selected && !isVisible && !airflow.isValid) {
                  onUpdateAirflow()
                }
                dispatch(toggleLayerVisibility({ layerKey: LayerKeys.AIRFLOW }))
              }}
            >
              Airflow Toggle
            </Switch>
          </>
        )}
        <Select
          selectedKey={airflow.selectedLayer?.evaluationHeight ?? 67}
          label="Evaluation Height"
          onSelectionChange={key => {
            if (typeof key !== 'number') {
              return
            }
            dispatch(setAirflowLayer(key))
          }}
        >
          {AIRFLOW_EVALUATION_POINTS.map(pt => {
            return (
              <SelectItem id={pt} key={pt}>
                {formatLength(pt)}
              </SelectItem>
            )
          })}
        </Select>
        <Separator orientation="vertical" />
        <FPMLegend
          options={{
            colors: colorScheme.map(c => c.color),
            xLabels: colorScheme.map(c => c.velocity),
            yLabels: ['Warm', 'Cool'],
          }}
        />
      </div>
    </Panel>
  )
}
